(function () {
  'use strict';

  var OVER = 3;

  if (!window.VTKabel) return;

  var MARGE = 0.05;

  function getal(x) {
    return Number(x).toLocaleString(document.documentElement.lang || undefined, { maximumFractionDigits: 1 });
  }

  function oordeel(auto, kabel, ctx) {
    if (auto.aansluiting && kabel.aansluiting &&
        auto.aansluiting !== kabel.aansluiting) {
      return { soort: 'past_niet' };
    }
    var uit = VTKabel.levert(auto, kabel.fasen, kabel.ampere);
    if (uit === null) return { soort: 'onbekend' };
    var beter = VTKabel.beste(auto, ctx.kabels);
    if (ctx.type && beter) {
      var zelfde = VTKabel.beste(auto, (ctx.kabels || []).filter(function (k) {
        return k.type === ctx.type;
      }));
      if (zelfde && !zelfde.kabel.huidig && zelfde.levert >= beter.levert - MARGE) beter = zelfde;
    }
    var raad = beter && !beter.kabel.huidig ? beter.kabel : null;

    if (uit < auto.kw - MARGE) {
      return { soort: 'gedeeltelijk', levert: uit, naar: raad };
    }

    if (raad && ctx.kabelKw && ctx.kabelKw - raad.kw > OVER) {
      return { soort: 'overmaat', levert: uit, naar: raad };
    }
    return { soort: 'volledig', levert: uit };
  }

  var LINK = (function () {
    try {
      var url = new URL(window.location.href);
      var auto = url.searchParams.get('auto');
      if (!auto) return null;
      var uit = { auto: auto, uitvoering: url.searchParams.get('uitvoering') || '' };
      url.searchParams.delete('auto');
      url.searchParams.delete('uitvoering');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      return uit;
    } catch (e) { return null; }
  })();

  document.querySelectorAll('[data-fit]').forEach(function (blok) {
    var catalogus = {};

    var kabel = {
      fasen: parseInt(blok.dataset.kabelFasen, 10),
      ampere: parseFloat(blok.dataset.kabelAmpere),
      aansluiting: blok.dataset.kabelAansluiting || ''
    };
    var kabels = [];
    var kabelBron = blok.parentNode.querySelector('[data-kabels]');
    if (kabelBron) {
      try { kabels = JSON.parse(kabelBron.textContent) || []; } catch (e) { kabels = []; }
    }
    var kabelKw = parseFloat(String(blok.dataset.kabelKw || '').replace(',', '.'));

    var kiesMerk = blok.querySelector('[data-fit-merk]');
    var kiesModel = blok.querySelector('[data-fit-model]');
    var uitvoer = blok.querySelector('[data-fit-out]');

    var uitvoering = VTKabel.uitvoeringVeld(blok.querySelector('[data-uitvoering]'));

    function gekozenModel() {
      var modellen = catalogus[kiesMerk.value] || [];
      return modellen[parseInt(kiesModel.value, 10)] || null;
    }

    function vulModellen(merkHandle) {
      kiesModel.innerHTML = '';
      var modellen = catalogus[merkHandle] || [];
      var leeg = document.createElement('option');
      leeg.value = '';
      leeg.textContent = kiesModel.dataset.leeg || '';
      kiesModel.appendChild(leeg);

      modellen.forEach(function (m, i) {
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = VTKabel.modelLabel(m);
        o.dataset.naam = m.naam;
        kiesModel.appendChild(o);
      });
      kiesModel.disabled = modellen.length === 0;
    }

    function zoekAuto() {
      var m = gekozenModel();
      if (!m) return null;
      var analyse = VTKabel.analyseerModel(m);
      return VTKabel.autoVoor(m, analyse, uitvoering ? uitvoering.select.value : '?');
    }

    var icoOk = uitvoer.querySelector('[data-fit-ico="ok"]');
    var icoWarn = uitvoer.querySelector('[data-fit-ico="warn"]');
    var veld = uitvoer.querySelector('[data-fit-tekst]');

    var TOESTAND = { volledig: 'ok', gedeeltelijk: 'warn',
                     overmaat: 'warn', past_niet: 'warn' };

    var ga = blok.querySelector('[data-fit-ga]');
    var laderKaart = blok.querySelector('[data-fit-lader]');

    var familie = blok.dataset.familie || '';
    var OPSLAG = 'vt-fit-auto';
    if (familie) {
      kabels = kabels.filter(function (k) { return !!k.familie; });
    }

    function leesOpslag() {
      try { return JSON.parse(sessionStorage.getItem(OPSLAG) || 'null'); } catch (e) { return null; }
    }
    function bewaar(st) {
      try { sessionStorage.setItem(OPSLAG, JSON.stringify(st)); } catch (e) {  }
    }
    function keuze() {
      var opt = kiesModel.options[kiesModel.selectedIndex];
      return {
        familie: familie,
        merk: kiesMerk.value,
        model: kiesModel.value,
        modelNaam: opt && opt.dataset ? opt.dataset.naam || '' : '',
        uitv: uitvoering ? uitvoering.select.value : ''
      };
    }
    function pad(url) {
      try { return new URL(url, window.location.href).pathname; } catch (e) { return url; }
    }

    function meld(detail) {
      blok.dispatchEvent(new CustomEvent('vt-fit:uitslag', { bubbles: true, detail: detail }));
    }

    function eigenschap(naam) {
      var form = familie && blok.closest('.vt-buy')
        ? blok.closest('.vt-buy').querySelector('form[action*="/cart/add"]') : null;
      if (!form) return;
      var veldje = form.querySelector('input[name="properties[_laadcheck]"]');
      if (!naam) { if (veldje) veldje.remove(); return; }
      if (!veldje) {
        veldje = document.createElement('input');
        veldje.type = 'hidden';
        veldje.name = 'properties[_laadcheck]';
        form.appendChild(veldje);
      }
      veldje.value = naam;
    }

    function leeg() {
      meld(null);
      eigenschap('');
      uitvoer.removeAttribute('data-state');
      icoOk.hidden = true;
      icoWarn.hidden = true;
      veld.innerHTML = '';
      if (ga) { ga.hidden = true; ga.removeAttribute('href'); }
      if (laderKaart) laderKaart.hidden = true;
    }

    function regel(staat, kop, sub) {
      uitvoer.setAttribute('data-state', staat);
      icoOk.hidden = staat !== 'ok';
      icoWarn.hidden = staat !== 'warn';
      veld.textContent = '';
      if (kop) {
        var b = document.createElement('b');
        b.textContent = kop;
        veld.appendChild(b);
      }
      if (sub) {
        var s = document.createElement('span');
        s.textContent = sub;
        veld.appendChild(s);
      }
      if (ga) { ga.hidden = true; ga.removeAttribute('href'); }
    }

    function toon(auto) {
      var r = oordeel(auto, kabel, { kabels: kabels, kabelKw: kabelKw, type: blok.dataset.kabelType || '' });
      eigenschap('');
      var staat = TOESTAND[r.soort];
      if (!staat) { leeg(); return; }

      if (laderKaart) laderKaart.hidden = true;
      if (!familie) bewaar(keuze());
      if (familie) {
        bewaar(keuze());
        var naam = auto.volnaam || auto.naam || '';

        if (blok.dataset.laderUrl && auto.kw && auto.kw <= 3.7 + MARGE) {
          var zin = vul(vul(blok.dataset.tekstStopcontact || '', 'naam', naam), 'max', getal(auto.kw));
          if (zin) {
            regel('warn', '', zin);
            if (laderKaart) laderKaart.hidden = false;
            else if (ga) {
              ga.href = blok.dataset.laderUrl;
              ga.textContent = vul(blok.dataset.tekstGa || '', 'naam', blok.dataset.laderNaam || '').trim();
              ga.hidden = !ga.textContent;
            }
            meld({ levert: r.levert, naam: naam, soort: 'volledig' });
            return;
          }
        }

        var naar = r.naar && r.naar.url && pad(r.naar.url) !== window.location.pathname ? r.naar : null;
        var d = blok.dataset;
        if (naar && (r.soort === 'gedeeltelijk' || r.soort === 'overmaat')) {
          var label = naar.label || naar.titel || '';
          var beter = VTKabel.levert(auto, naar.fasen, naar.ampere);
          var kop, sub;
          if (r.soort === 'gedeeltelijk') {
            kop = vul(vul(d.tekstBeterKop || '', 'kabel', label), 'naam', naam);
            var autoA = parseFloat(auto.stroom);
            sub = parseInt(auto.fasen, 10) === 1 && autoA > kabel.ampere && d.tekstBeterFase
              ? vul(d.tekstBeterFase, 'ampere', getal(autoA))
              : d.tekstBeterSub || '';
            sub = vul(vul(vul(sub, 'levert', getal(r.levert)), 'beter', getal(beter)), 'kabel', label);
            if (auto.onbekend && blok.dataset.tekstOnbekend) {
              sub = vul(blok.dataset.tekstOnbekend, 'naam', naam);
            }
          } else {
            kop = vul(vul(d.tekstGenoegKop || '', 'kabel', label), 'naam', naam);
            sub = vul(d.tekstGenoegSub || '', 'max', getal(auto.kw));
          }
          regel('warn', kop, sub);
          if (ga) {
            ga.textContent = '';
            var waar = document.createElement('span');
            waar.textContent = vul(d.tekstBekijk || '', 'kabel', label);
            ga.appendChild(waar);
            if (naar.prijs) {
              var bedrag = document.createElement('span');
              bedrag.textContent = naar.prijs;
              ga.appendChild(bedrag);
            }
            ga.href = naar.url;
            ga.hidden = false;
          }
          meld({ levert: r.levert, naam: naam, soort: r.soort });
          return;
        }

        if (r.soort === 'volledig' || r.soort === 'overmaat') {
          var max = r.levert >= auto.kw - MARGE;
          regel('ok',
            vul(d.tekstBeste || '', 'naam', naam),
            vul(max ? d.tekstBesteSub || '' : d.tekstPastSub || '', 'levert', getal(r.levert)));
          eigenschap(naam);
          meld({ levert: r.levert, naam: naam, soort: 'volledig' });
          return;
        }
      }

      uitvoer.setAttribute('data-state', staat);
      meld(r.soort === 'past_niet' || !r.levert ? null
        : { levert: r.levert, naam: auto.volnaam || auto.naam || '', soort: r.soort });
      icoOk.hidden = staat !== 'ok';
      icoWarn.hidden = staat !== 'warn';
      veld.innerHTML = tekst(r.soort, auto, r);

      var merklink = familie ? null : blok.querySelector('[data-fit-merklink]');
      if (merklink) {
        if (auto && auto.merk && auto.merkurl) {
          merklink.href = auto.merkurl;
          merklink.textContent = (merklink.dataset.tekst || '').replace('[merk]', auto.merk) + ' \u2192';
          merklink.hidden = false;
        } else {
          merklink.hidden = true;
          merklink.removeAttribute('href');
        }
      }

      if (!ga || familie) return;
      var doel = r.naar;
      if (doel && doel.url) {
        ga.href = doel.url;
        var label = vul(blok.dataset.tekstGa || '', 'naam', doel.titel).trim();
        if (label) {
          ga.textContent = label + ' \u2192';
          ga.hidden = false;
        } else {
          ga.hidden = true;
          ga.removeAttribute('href');
        }
      } else {
        ga.hidden = true;
        ga.removeAttribute('href');
      }
    }

    var SJABLOON = {
      volledig: blok.dataset.tekstVolledig || '',
      gedeeltelijk: blok.dataset.tekstGedeeltelijk || '',
      gedeeltelijk_naar: blok.dataset.tekstGedeeltelijkNaar || '',
      gedeeltelijk_paal: blok.dataset.tekstGedeeltelijkPaal || '',
      overmaat: blok.dataset.tekstOvermaat || '',
      past_niet: blok.dataset.tekstPastNiet || ''
    };

    function vul(sjabloon, sleutel, waarde) {
      var re = new RegExp('\\{\\{?\\s*' + sleutel + '\\s*\\}?\\}', 'g');
      return sjabloon.replace(re, waarde);
    }

    function duur(uren) {
      var d = blok.dataset;
      var min = Math.max(5, Math.round((uren * 60) / 5) * 5);
      if (min < 60) return vul(d.duurMin || '', 'n', String(min));
      var u = Math.floor(min / 60);
      var m = min - u * 60;
      if (!m) return vul(d.duurUur || '', 'u', String(u));
      return vul(vul(d.duurUurMin || '', 'u', String(u)), 'm', String(m));
    }

    function kmRegel(kw) {
      var d = blok.dataset;
      var verbruik = parseFloat(String(d.verbruik || '').replace(',', '.'));
      var dagrit = parseFloat(d.dagrit);
      if (!verbruik || !kw || !d.tekstKm) return '';
      var perUur = Math.round((kw / verbruik) * 100);
      var out = vul(d.tekstKm, 'uur', String(perUur));
      return vul(out, 'dag', duur(((dagrit || 0) * verbruik) / 100 / kw));
    }

    function tekst(soort, auto, r) {
      var sjabloon = SJABLOON[soort] || '';
      var naar = r.naar;
      var beter = naar ? VTKabel.levert(auto, naar.fasen, naar.ampere) : null;
      if (soort === 'gedeeltelijk' && naar && SJABLOON.gedeeltelijk_naar) {
        var anderType = naar.type && blok.dataset.kabelType && naar.type !== blok.dataset.kabelType;
        if (beter !== null && beter > r.levert + MARGE) {
          sjabloon = anderType && SJABLOON.gedeeltelijk_paal ? SJABLOON.gedeeltelijk_paal : SJABLOON.gedeeltelijk_naar;
        } else {
          sjabloon = anderType ? SJABLOON.gedeeltelijk : SJABLOON.overmaat;
        }
      }
      if (soort === 'overmaat' && naar && naar.type && blok.dataset.kabelType &&
          naar.type !== blok.dataset.kabelType && blok.dataset.kabelType && SJABLOON.volledig) {
        sjabloon = SJABLOON.volledig;
      }
      var out = sjabloon;
      if (naar) {
        out = vul(out, 'beter', beter === null ? '' : getal(beter));
        out = vul(out, 'ander', naar.titel || '');
      }
      out = vul(out, 'levert', r.levert === undefined ? '' : getal(r.levert));
      out = vul(out, 'max', auto.kw ? getal(auto.kw) : '');
      out = vul(out, 'naam', auto.volnaam || auto.naam || '');
      if (auto.onbekend && blok.dataset.tekstOnbekend) {
        out += ' ' + vul(blok.dataset.tekstOnbekend, 'naam', auto.volnaam || auto.naam || '');
      }
      if (soort !== 'past_niet' && r.levert && !blok.hasAttribute('data-km-apart')) {
        var km = kmRegel(r.levert);
        if (km) out += ' ' + km;
      }
      return out;
    }

    kiesMerk.addEventListener('change', function () {
      leeg();
      if (uitvoering) uitvoering.verberg();
      if (!kiesMerk.value) {
        kiesModel.disabled = true;
        kiesModel.innerHTML = '';
        var eerst = document.createElement('option');
        eerst.value = '';
        eerst.textContent = kiesModel.dataset.eerst || '';
        kiesModel.appendChild(eerst);
        return;
      }
      var handle = kiesMerk.value;
      kiesModel.disabled = true;
      window.VTCatalogus.laad().then(function (c) {
        catalogus = c || {};
        if (kiesMerk.value === handle) vulModellen(handle);
      }).catch(function () {
        kiesModel.disabled = true;
      });
    });

    kiesModel.addEventListener('change', function () {
      leeg();
      if (uitvoering) {
        var m = gekozenModel();
        var analyse = m ? VTKabel.analyseerModel(m) : null;
        if (analyse && analyse.vraag) uitvoering.toon(m, analyse);
        else uitvoering.verberg();
      }
      direct();
    });
    if (uitvoering) uitvoering.select.addEventListener('change', function () { leeg(); direct(); });

    function direct() {
      if (!familie) return;
      var auto = zoekAuto();
      if (!auto) return;
      toon(auto);
      if (uitvoer.hasAttribute('data-state')) bekend(auto);
    }

    var knop = blok.querySelector('[data-fit-go]');
    if (knop) {
      knop.addEventListener('click', function () {
        var auto = zoekAuto();
        if (auto) {
          toon(auto);
          if (familie && uitvoer.hasAttribute('data-state')) bekend(auto);
          return;
        }
        leeg();
        if (!kiesMerk.value) {
          kiesMerk.focus();
        } else if (!kiesModel.value) {
          kiesModel.focus();
        } else if (uitvoering && !uitvoering.select.closest('[hidden]') && !uitvoering.select.value) {
          uitvoering.select.focus();
        }
      });
    }

    function uitLink(c) {
      var eind = '/' + LINK.auto;
      for (var merk in c) {
        var lijst = c[merk] || [];
        for (var i = 0; i < lijst.length; i++) {
          var u = pad(lijst[i].url || '');
          if (u.slice(-eind.length) !== eind) continue;
          var uitv = '';
          (lijst[i].varianten || []).forEach(function (v, j) {
            if (LINK.uitvoering && v.handle === LINK.uitvoering) uitv = String(j);
          });
          return { familie: familie, merk: merk, model: String(i), modelNaam: lijst[i].naam, uitv: uitv };
        }
      }
      return null;
    }

    var kopTekst = blok.querySelector('.vt-fit__head b');
    var kopOrigineel = kopTekst ? kopTekst.textContent : '';
    var ander = blok.querySelector('[data-fit-ander]');
    function bekend(auto) {
      blok.classList.add('is-bekend');
      if (kopTekst && blok.dataset.tekstBekend) {
        kopTekst.textContent = vul(blok.dataset.tekstBekend, 'naam', auto.volnaam || auto.naam || '');
      }
      if (ander) ander.hidden = false;
    }
    if (ander) {
      ander.addEventListener('click', function () {
        blok.classList.remove('is-bekend');
        leeg();
        if (kopTekst) kopTekst.textContent = kopOrigineel;
        ander.hidden = true;
        var d = blok.querySelector('details');
        if (d) d.open = true;
        kiesMerk.focus();
      });
    }

    var vel = blok.querySelector('[data-fit-vel]');
    if (vel) {
      var merkVak = vel.querySelector('[data-fit-merken]');
      var modelVak = vel.querySelector('[data-fit-modellen]');
      var merkNaam = vel.querySelector('[data-fit-merknaam]');
      var stappen = vel.querySelectorAll('[data-fit-stap]');
      var norm = function (s) {
        return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      };
      var opties = Array.prototype.slice.call(kiesMerk.options);
      (blok.dataset.merkKnoppen || '').split(',').forEach(function (naam) {
        var o = opties.filter(function (x) { return x.value && norm(x.textContent) === norm(naam); })[0];
        if (!o) return;
        var k = document.createElement('button');
        k.type = 'button';
        k.dataset.merk = o.value;
        k.textContent = o.textContent;
        merkVak.appendChild(k);
      });
      merkVak.hidden = !merkVak.children.length;

      var stap = function (welke) {
        Array.prototype.forEach.call(stappen, function (s) { s.hidden = s.dataset.fitStap !== welke; });
      };
      var modelKnoppen = function () {
        modelVak.textContent = '';
        var o = kiesMerk.options[kiesMerk.selectedIndex];
        merkNaam.textContent = o && o.value ? o.textContent : '';
        if (kiesModel.disabled) return;
        Array.prototype.forEach.call(kiesModel.options, function (m) {
          if (!m.value) return;
          var k = document.createElement('button');
          k.type = 'button';
          k.dataset.model = m.value;
          k.textContent = m.textContent;
          k.setAttribute('aria-pressed', String(m.value === kiesModel.value));
          modelVak.appendChild(k);
        });
      };
      new MutationObserver(modelKnoppen).observe(kiesModel, { childList: true });
      var open = function () {
        if (window.VTCatalogus) window.VTCatalogus.laad().catch(function () {});
        stap(kiesMerk.value && kiesModel.options.length > 1 ? 'model' : 'merk');
        if (window.VtDialoog) window.VtDialoog.open(vel); else vel.showModal();
      };
      var dicht = function () {
        if (window.VtDialoog) window.VtDialoog.sluit(vel); else vel.close();
      };
      blok.querySelector('[data-fit-open]').addEventListener('click', open);
      if (ander) ander.addEventListener('click', open);
      kiesMerk.addEventListener('change', function () {
        if (!kiesMerk.value) return;
        modelKnoppen();
        stap('model');
        var handle = kiesMerk.value;
        if (window.VTCatalogus) window.VTCatalogus.laad().then(function () {
          setTimeout(function () {
            if (kiesMerk.value !== handle) return;
            modelKnoppen();
            if (!modelVak.children.length && kiesModel.options.length <= 1) {
              var geen = document.createElement('p');
              geen.className = 'vt-fit__geen';
              geen.textContent = vel.dataset.tekstGeen || '';
              modelVak.appendChild(geen);
            }
          }, 0);
        }).catch(function () {});
      });
      vel.addEventListener('click', function (e) {
        var merk = e.target.closest('[data-merk]');
        if (merk) {
          kiesMerk.value = merk.dataset.merk;
          kiesMerk.dispatchEvent(new Event('change'));
          return;
        }
        var model = e.target.closest('[data-model]');
        if (model) {
          kiesModel.value = model.dataset.model;
          kiesModel.dispatchEvent(new Event('change'));
          modelKnoppen();
          return;
        }
        if (e.target.closest('[data-fit-terug]')) { stap('merk'); return; }
        if (e.target.closest('[data-fit-sluit]')) dicht();
      });
      new MutationObserver(function () {
        if (blok.classList.contains('is-bekend') && vel.open) dicht();
      }).observe(blok, { attributes: true, attributeFilter: ['class'] });
    }

    function herstel() {
      if (!blok.closest('.vt-buy, vt-autocheck')) return;
      var st = leesOpslag();
      if (!LINK && (!st || st.familie === undefined || !st.merk)) return;
      if (!window.VTCatalogus) return;
      window.VTCatalogus.laad().then(function (c) {
        catalogus = c || {};
        if (LINK) st = uitLink(catalogus) || st;
        if (!st || !st.merk) return;
        var heeftMerk = Array.prototype.some.call(kiesMerk.options, function (o) { return o.value === st.merk; });
        if (!heeftMerk) return;
        kiesMerk.value = st.merk;
        vulModellen(st.merk);
        var opt = kiesModel.querySelector('option[value="' + st.model + '"]');
        if (!opt || (st.modelNaam && opt.dataset.naam !== st.modelNaam)) return;
        kiesModel.value = st.model;
        var m = gekozenModel();
        var analyse = m ? VTKabel.analyseerModel(m) : null;
        if (uitvoering) {
          if (analyse && analyse.vraag) {
            uitvoering.toon(m, analyse);
            if (st.uitv) uitvoering.select.value = st.uitv;
          } else {
            uitvoering.verberg();
          }
        }
        var d = blok.querySelector('details');
        var auto = zoekAuto();
        if (!auto) return;
        if (d) d.open = true;
        toon(auto);
        if (uitvoer.hasAttribute('data-state')) bekend(auto);
      }).catch(function () {  });
    }
    if (document.readyState === 'complete') herstel();
    else window.addEventListener('load', herstel);
  });
})();
